import Swiper, { Navigation } from 'swiper';
import 'swiper/css';

const selectors = {
  carouselWrapper: '[data-generic-cards-carousel]',
};

class GenericCardsCarousel extends HTMLElement {
  constructor() {
    super();

    document.addEventListener('DOMContentLoaded', () => {
      this.carouselWrappers = this.querySelectorAll(selectors.carouselWrapper);

      if (this.carouselWrappers.length === 0) {
        return;
      }

      this.showCarousel =
        this.carouselWrappers[0].dataset.showCarousel || 'Both';
      this.breakpoint = window.matchMedia('(max-width:767px)');

      if (
        (this.showCarousel === 'Desktop Only' && this.breakpoint.matches) ||
        (this.showCarousel === 'Mobile Only' && !this.breakpoint.matches)
      ) {
        return;
      }

      this.render();
    });
  }

  render() {
    // Init the carousel on load.
    this.init();

    // Subsequently, on resize, we need to check if we need a Swiper object checking the break point.
    // If not, it will get destroyed.
    this.registerEventListeners();
  }

  init() {
    if (this.carousel) {
      // Clean up the swiper object for re-initialisation.
      this.carousel.destroy();
    }

    this.initCarousels();
  }

  initCarousels() {
    this.carousel = new Swiper(selectors.carouselWrapper, {
      modules: [Navigation],
      freeMode: true,
      slidesPerView: 'auto',
      spaceBetween: 10,
      watchOverflow: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        768: {
          spaceBetween: 20,
        },
      },
    });
  }

  registerEventListeners() {
    window.addEventListener('resize', () => {
      this.initCarousels();
    });
  }
}

customElements.define('generic-cards-carousel', GenericCardsCarousel);
